module.exports = __webpack_public_path__ + "img/insurances-plans.6f1ba4eb.svg";